export const iosStoreUrl = 'https://apps.apple.com/us/app/jetfly-simply-closer/id1504916237'
export const androidStoreUrl = 'https://play.google.com/store/apps/details?id=com.jetfly.jetfly&hl=en'
